export enum RegistrationStep {
  ACCOUNT = 'account',
  COMPANY = 'company',
}

export interface CheckEmailResponse {
  emailType: 'professional' | 'freemail' | 'invalid';
  domain: string;
  companyExists: boolean;
  companyName?: string;
  companyId?: string;
  checkedEmail?: string; // Add the original email that was checked
  emailAlreadyExists: boolean;
  isDeleted: boolean;
}

export interface CreateAccountData {
  email: string;
  password: string;
  confirmPassword: string;
  firstName?: string;
  lastName?: string;
  agreedToTerms: boolean;
}

export interface CompanyAddress {
  street?: string;
  streetNumber?: string;
  city?: string;
  zipCode?: string;
  country?: string;
}

export interface CompanySetupData {
  companyName: string;
  country: string;
  organisationType: string;
  numberOfEmployees: string;
  userRole: string;
  promoCode?: string;
  inviteEmails?: string[];
  address?: CompanyAddress;
  vatNumber?: string;
}

export interface SelfRegisterRequest {
  // User data from step 1
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phone?: string;
  preferredLanguage?: string;
  userRole?: string;
  agreedToTerms?: boolean;
  agreedToPrivacy?: boolean;

  // Company data from step 2
  companyName: string;
  organisationType?: string;
  size?: string;
  promoCode?: string;
  inviteEmails?: string;
  companyDetails: {
    vatNumber?: string;
    address?: CompanyAddress;
  };
}

export interface CompanyMatch {
  id: string;
  name: string;
  similarity: number;
}

export interface CheckCompanyNameResponse {
  isAvailable: boolean;
  matches: CompanyMatch[];
}

export interface RegistrationState {
  currentStep: RegistrationStep;
  accountData?: CreateAccountData;
  companyData?: CompanySetupData;
  emailCheckResult?: CheckEmailResponse;
  isLoading: boolean;
  error?: string;
}

export interface RegistrationSuccess {
  success: boolean;
  message: string;
  redirectUrl?: string;
}

// Dropdown options
export interface DropdownOption {
  label: string;
  value: string;
}

// Form validation states
export interface EmailValidationState {
  emailType?: 'professional' | 'freemail' | 'invalid';
  isValid?: boolean;
  message?: string;
  isChecking?: boolean;
}
